import React from 'react';
import ReactDOM from 'react-dom';
import {usePromiseTracker} from "react-promise-tracker";
import './index.css';
import {App} from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import store from './redux/store'

const LoadingIndicator = props => {
    const { promiseInProgress } = usePromiseTracker ();
    return (
        promiseInProgress &&
        <div id={"my-modal"}>
            <div className={"image"}>
                <img id={"spinner"} src={require ( './images/logo.jpg' )} alt={"logo"}/>
                <div className="spin spinner"></div>
            </div>
        </div>
    );
};

ReactDOM.render (
    <Provider store={store}>
        <App/>
        <LoadingIndicator/>
    </Provider> ,
    document.getElementById ( 'root' )
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister ();
